// Form field names shared by the bot checks (lib/auth/bot-check.ts, server
// only) and the forms that carry them (client components).
export const HONEYPOT_FIELD = "website";
export const FORM_TOKEN_FIELD = "formToken";
export const TURNSTILE_RESPONSE_FIELD = "cf-turnstile-response";
